<template>
  <div>
    <div ref="Hierarchy" id="Hierarchy"></div>
  </div>
</template>
<script>
import echarts from "echarts"
export default {
  props: ["Hierarchy"],
  data() {
    return {};
  },
  methods: {},
  watch: {
    Hierarchy(newval) {
      if (newval) {
        let cengjiArr = newval;
      let option = {
          toolbox: {
            feature: {
              restore: {},
              saveAsImage: {}
            }
          },
          series: [
            {
              name: "漏斗图",
              type: "funnel",
              left: "10%",
              top: 40, //60,
              //x2: 80,
              bottom: 30, //60,
              width: "80%",
              // height: {totalHeight} - y - y2,
              min: 0,
              max: 100,
              minSize: "0%",
              maxSize: "100%",
              sort: "ascending", //'descending'(倒金字塔),
              gap: 2,
              color: [
                "#DB5D4F",
                "#FFB553",
                "#FFB553",
                "#FFB553",
                "#FFB553",
                "#5b6bcf",
                "#5b6bcf",
                "#5b6bcf",
                "#5b6bcf",
                "#5b6bcf"
              ],
              label: {
                show: true,
                position: "inside" //'right'//'inside'   //线显示的位置
              },
              labelLine: {
                length: 5, //线的长度
                lineStyle: {
                  width: 1,
                  // lable:'right',
                  type: "solid"
                }
              },
              itemStyle: {
                borderColor: "#fff",
                borderWidth: 1
              },
              emphasis: {
                label: {
                  fontSize: 20
                }
              },
              data: cengjiArr
            }
          ]
        };
        setTimeout(()=>{
          var myChart = echarts.init(this.$refs.Hierarchy);
        myChart && myChart.setOption(option)
        },1000)
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#Hierarchy{
  width: 100%;
  height: 100%;
}
</style>